import { render, staticRenderFns } from "./BusinessSubscriptionView.vue?vue&type=template&id=5fa30b7b&scoped=true&"
import script from "./BusinessSubscriptionView.vue?vue&type=script&lang=ts&"
export * from "./BusinessSubscriptionView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessSubscriptionView.vue?vue&type=style&index=0&id=5fa30b7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa30b7b",
  null
  
)

export default component.exports